module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDIwIDE4Ij4KICAgIDxwYXRoIGZpbGw9IiNDQUNGQ0QiIGQ9Ik0xMC41NDcuMzg2bDIuMDU3IDUuOTgzIDYuNDI0LjA3M2MuNTUzLjAwNi43ODIuNjk4LjMzOCAxLjAyMmwtNS4xNTQgMy43NyAxLjkxNSA2LjAyN2MuMTY0LjUxOS0uNDM1Ljk0Ni0uODg2LjYzMmwtNS4yNC0zLjY1Mi01LjI0MiAzLjY1MWMtLjQ1LjMxNC0xLjA1LS4xMTQtLjg4Ni0uNjMybDEuOTE1LTYuMDI3LTUuMTU0LTMuNzdDLjE5IDcuMTQuNDE5IDYuNDQ4Ljk3MiA2LjQ0Mmw2LjQyNC0uMDczTDkuNDUzLjM4NmMuMTc3LS41MTUuOTE4LS41MTUgMS4wOTQgMHoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/component/evaluation/star_gray_large.svg
// module id = pkvk
// module chunks = 30